export default __webpack_public_path__ + "static/media/dots_circle_hover.e91e4e0f.png";